import styled from 'styled-components';

export const Block = styled.div`
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid var(--surface-d);

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
  h4 {
    margin-top: 0;
    margin-bottom: 0;
  }

  .title-container {
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-bottom: 16px;
  }

  .store-icon {
    width: 24px;
    height: 24px;
  }
`;

export const FieldsContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: flex-start;
  margin-bottom: 1rem;

  .field {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 300px;
    min-height: 90px;

    label {
      white-space: nowrap;
    }
  }
`;
